module.exports = __webpack_public_path__ + "static/media/work-01-small.31375b0d.jpg";